import React, { Component } from 'react'
import Field from './components/Field/Field';

class App extends Component {
  render() {
    return (
      <Field />
    )
  }
}

export default App;
